module.exports = __webpack_public_path__ + "src/assets/img/status-white.33658588.svg";